module.exports = __webpack_public_path__ + "img/202504_01_sp.02eee7b3.jpg";